import { useTranslation } from 'react-i18next';

import { Option } from '../components/shared/ControlledFields/ControlledSelect';

function getLabel<T>(
  labelGetter: keyof T | (keyof T)[],
  item: T,
  joinBy = ''
): string {
  if (Array.isArray(labelGetter)) {
    return labelGetter.map((key) => String(item[key])).join(joinBy);
  }

  return String(item[labelGetter]);
}

export function useGetOptions<T extends object>(
  data: T[],
  isError = false,
  valueGetter: keyof T,
  labelGetter: keyof T | (keyof T)[],
  translationKey?: string,
  joinBy?: string
): Option[] {
  'use memo';
  const { t } = useTranslation('common');

  if (isError || !data) return [];

  return data.map((item) => ({
    value: item[valueGetter] as string | number,
    label: translationKey
      ? t(`${translationKey}${getLabel(labelGetter, item, joinBy)}`)
      : getLabel(labelGetter, item, joinBy)
  }));
}
